export default __webpack_public_path__ + "static/media/1384.0bc89285.png";